export default "__VITE_PUBLIC_ASSET__3cb1bdd4__"